


















import { Component, Prop, Vue } from "vue-property-decorator";
import { getters, actions } from "@/observables";
const URL_WC_TENDER_DEVELOPMENT =
  "https://solinftec.github.io/solinftec-wc-monitoramento-tender-truck/wc-monitoramento-tender-truck.min.js";
const URL_WC_TENDER_HOMOLOGATION =
  "https://wc-tender-truck-homologation.onrender.com/wc-monitoramento-tender-truck.min.js";
const URL_WC_TENDER_PRODUCTION =
  "https://wc-tender-truck.onrender.com/wc-monitoramento-tender-truck.min.js";

@Component({})
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() tenderId!: number | null;

  /* Computed */
  get bindingsWc() {
    return {
      "url-sgp": getters.getUrlSgp(),
      token: getters.getToken(),
      unidades: getters.getUnidade().join(","),
      "cd-cliente": getters.getCdCliente(),
      grupo: getters.getGrupo(),
      "cd-tender-truck": this.tenderId,
      "show-tender-selection": this.tenderId ? "N" : "Y"
    };
  }

  get show() {
    if (this.visible) {
      if (!customElements.get("wc-monitoramento-tender-truck")) {
        const script = document.createElement("script");
        script.async = false;

        switch (getters.getEnvironmentStage()) {
          case "P":
            script.src = URL_WC_TENDER_PRODUCTION;
            break;
          case "H":
            script.src = URL_WC_TENDER_HOMOLOGATION;
            break;
          case "D":
            script.src = URL_WC_TENDER_DEVELOPMENT;
            break;
          default:
            script.src = URL_WC_TENDER_PRODUCTION;
            break;
        }

        document.head.appendChild(script);
      }
    }
    return this.visible;
  }

  set show(value: boolean) {
    if (!value) {
      this.$emit("close");
    }
  }

  /* Methods */
  /* Evento do wc do tender quando uma trip é modificada */
  onChangeInTrip() {
    actions.fetchLoads();
  }
}
